/**
 * 랙 판(`RackPlate`)의 치수와 포켓 경로 — 컴포넌트 파일과 갈라 둔 것은 fast refresh 규칙 때문이다
 * (컴포넌트 파일은 컴포넌트만 내보낸다). 랩웨어 배치(`labwareLayout`)도 이 값을 읽는다.
 */

/** 판 바깥 여백 · 포켓 둘레 살 폭 · 포켓 귀 모따기 · 긴 변 홈 반지름 · 나사 자리 · 나사 반지름 */
export const PLATE_EDGE = 2
export const PLATE_RIM = 5
export const PLATE_CHAMFER = 7
export const PLATE_NOTCH = 3.5
export const SCREW_AT = 6
export const SCREW_R = 1.7

/** 포켓 안쪽 경계까지의 거리 — 구멍은 이 안에 선다 */
export const PLATE_INSET = PLATE_EDGE + PLATE_RIM

/** 데크 판(사진)의 짧은 변 · 긴 변 — 치수를 모르는 정의가 빌려 쓰는 판 크기다 */
export const DECK_PLATE_SHORT = 90
export const DECK_PLATE_LONG = 126
/**
 * TC 적재소 판의 폭 · 높이(그림 좌표) — 가로로 긴 판(eric 2026-10-19 실물 사진 · 긴 변 : 짧은 변 ≈ 2.3). 그림(`DeckRackFigure`)과
 * 소모품 판의 축 틀(`RackAxesFrame` · 라벨 자리 비율)이 같은 값을 읽는다
 */
export const TC_PLATE_W = 172
export const TC_PLATE_H = 75

const f = (v: number) => String(Math.round(v * 100) / 100)

/**
 * 포켓 안쪽 경계 · 귀 모따기 — 기본은 사진에서 잰 값(`PLATE_INSET` · `PLATE_CHAMFER`).
 * 🔴 Opentrons 정의의 구멍이 그보다 판 끝에 가까우면 **포켓이 물러난다**(`pocketClearing`) — 구멍 자리는
 *    정의가 이기고, 우리가 사진에서 지은 포켓 선이 구멍을 가로지르지 않게 한다(2026-09-27).
 */
export interface PocketFit {
  inset: number
  chamfer: number
}

/**
 * 포켓 경로. 시계 방향으로 돌며 홈의 호는 모두 `sweep=1` — 진행 방향의 왼쪽 = 판 바깥(살 쪽)으로 파인다.
 * 세로 판은 좌 · 우 긴 변에, 가로 판은 위 · 아래 긴 변에 홈이 선다.
 */
export function pocketPath(width: number, height: number, pocket?: PocketFit): string {
  const inset = pocket?.inset ?? PLATE_INSET
  const L = inset
  const T = inset
  const R = width - inset
  const B = height - inset
  const C = pocket?.chamfer ?? PLATE_CHAMFER
  const N = PLATE_NOTCH
  if (height >= width) {
    const MID = height / 2
    return [
      `M${f(L + C)} ${f(T)}`,
      `L${f(R - C)} ${f(T)}`,
      `L${f(R)} ${f(T + C)}`,
      `L${f(R)} ${f(MID - N)}`,
      `A${f(N)} ${f(N)} 0 0 1 ${f(R)} ${f(MID + N)}`,
      `L${f(R)} ${f(B - C)}`,
      `L${f(R - C)} ${f(B)}`,
      `L${f(L + C)} ${f(B)}`,
      `L${f(L)} ${f(B - C)}`,
      `L${f(L)} ${f(MID + N)}`,
      `A${f(N)} ${f(N)} 0 0 1 ${f(L)} ${f(MID - N)}`,
      `L${f(L)} ${f(T + C)}`,
      'Z',
    ].join(' ')
  }
  const MID = width / 2
  return [
    `M${f(L + C)} ${f(T)}`,
    `L${f(MID - N)} ${f(T)}`,
    `A${f(N)} ${f(N)} 0 0 1 ${f(MID + N)} ${f(T)}`,
    `L${f(R - C)} ${f(T)}`,
    `L${f(R)} ${f(T + C)}`,
    `L${f(R)} ${f(B - C)}`,
    `L${f(R - C)} ${f(B)}`,
    `L${f(MID + N)} ${f(B)}`,
    `A${f(N)} ${f(N)} 0 0 1 ${f(MID - N)} ${f(B)}`,
    `L${f(L + C)} ${f(B)}`,
    `L${f(L)} ${f(B - C)}`,
    `L${f(L)} ${f(T + C)}`,
    'Z',
  ].join(' ')
}
